<template>
  <div v-if="store.form.currentStep=== 'stepTwo'">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>
    <hr class="d-md-none ml-3 mr-3">

    <div class="pl-3 pl-lg-1 pr-4 pt-2 pb-4">
      <form>

        <!--        UDAJE O SUBJEKTU START-->
        <div class="row" v-if="this.store.order.type === 'order'">
          <h6 class=" col-12 text-primary mt-3 mb-2 font-weight-bold">{{
              t('personalForm.headers.onAddressWillBe')
            }}</h6>
          <!--          INPUT ICO-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'order'">
            <div class="form-label-group mb-1">
              <input type="text" id="ico" class="form-control"
                     :class="{'is-invalid': (isBlurred() || wrongIco) && (!store.order.contactInfo.address.companyAddress.ico || store.order.contactInfo.address.companyAddress.ico.length < 8)}"
                     style="background-image: none!important;"
                     v-model="store.order.contactInfo.address.companyAddress.ico"
                     v-on:input="preventIcoInputFromLetter"
                     placeholder="{{ t('personalForm.ico') }}"
                     required=""/>
              <label for="postCode"> {{ t('personalForm.ico') }}</label>
              <button v-if="!aresLoading"
                      class="ares-button py-0 btn btn-sm btn-outline-primary text-uppercase"
                      v-on:click="loadFromAres">
                {{ t('buttons.loadFromAres') }}
              </button>
              <!--              <span v-if="aresLoading"-->
              <!--                    class="ares-button py-0 btn btn-sm btn-outline-danger text-uppercase">-->
              <!--                    {{ t('buttons.loadFromAres') }}-->
              <!--              </span>-->
              <button v-if="aresLoading"
                      class="ares-button py-0 btn btn-sm btn-outline-primary text-uppercase"
                      disabled>
                {{ t('buttons.loadFromAres') }}
              </button>
              <div id="IcoMessage" class="invalid-feedback">
                {{ t('personalForm.required.ico') }}
              </div>
            </div>
          </div>


          <!--          INPUT DIC-->
          <div v-if="store.form.mamIco === 'mam' && store.order.type === 'order'" class="col-12 col-sm-6">
            <InputText v-model="store.order.contactInfo.address.companyAddress.dic" label-name="personalForm.dic"
                       id="dic"
                       step="stepTwo"/>
          </div>

          <!--          INPUT COMPANY NAME-->
          <div class="col-12 col-sm-6" v-if="store.form.osoba === 'pravnicka'">
            <!--            <tooltip title="firmaJizExistuje"></tooltip>-->
            <InputText v-if="store.form.mamIco === 'mam'"
                       v-model="store.order.contactInfo.address.companyAddress.companyName"
                       label-name="personalForm.companyName"
                       autocomplete="organization"
                       id="companyName"
                       required="personalForm.required.companyName" step="stepTwo"/>
            <InputText v-else
                       v-model="store.order.contactInfo.address.companyAddress.companyName"
                       label-name="personalForm.companyNameNoIco"
                       autocomplete="organization"
                       id="companyName"
                       required="personalForm.required.companyName" step="stepTwo"/>
          </div>
          <div class="col-12 col-sm-6" v-if="store.form.osoba === 'fyzicka'">
            <InputText v-model="store.order.contactInfo.address.companyAddress.companyName"
                       label-name="personalForm.osvcName"
                       id="name"
                       autocomplete="name"
                       required="personalForm.required.osvcName" step="stepTwo"/>
          </div>


          <!--          INPUT STREET-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'order'">
            <InputText v-model="store.order.contactInfo.address.companyAddress.street" label-name="personalForm.street"
                       id="street"
                       required="personalForm.required.street" step="stepTwo" tip="street"/>
          </div>

          <!--          INPUT CITY-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'order'">
            <InputText v-model="store.order.contactInfo.address.companyAddress.city" label-name="personalForm.city"
                       id="city"
                       required="personalForm.required.city" step="stepTwo"/>
          </div>

          <!--          INPUT PSC START-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'order'">
            <div class="form-label-group mb-1">
              <input type="text" id="postCode" class="form-control"
                     :class="{'is-invalid': isBlurred() && !store.order.contactInfo.address.companyAddress.psc}"
                     v-model="store.order.contactInfo.address.companyAddress.psc"
                     v-on:input="preventPscInputFromLetter"
                     v-on:change="store.pscFilterInvoice()"
                     placeholder="{{ t('personalForm.psc') }}"
                     required=""/>
              <label for="postCode"> {{ t('personalForm.psc') }}</label>
              <div id="validationServer05Feedback" class="invalid-feedback">
                {{ t('personalForm.required.psc') }}
              </div>
            </div>
          </div>
          <!--          INPUT PSC END-->

          <!--          INPUT ZEMĚ START-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'order'">
            <div class="dropdown jake-dropdown mb-3"
                 v-if="store.order.contactInfo.address.companyAddress.country.value !== 'others'">
              <span class="label">{{ t('personalForm.country') }}</span>
              <a class=" dropdown-toggle" href="#" role="button" data-toggle="dropdown"
                 aria-expanded="false">
              <span v-if="store.order.contactInfo.address.companyAddress.country">

                {{ t('personalForm.countries.' + store.order.contactInfo.address.companyAddress.country.value) }}
              </span>
              </a>

              <div class="dropdown-menu" aria-labelledby="dropdownPhone">
                    <span class="dropdown-item-text text-uppercase text-muted">
            <small>{{t('personalForm.countries.select')}}</small></span>
                <span class="dropdown-item cursorLink" v-for="item in form.countries"
                      @click="setCountry(item)">
         <img v-if="item.iconFile" width="20" style="vertical-align: text-bottom"
              v-bind:src="item.iconFile" alt=""/>
                  {{ t('personalForm.countries.' + item.value) }}
                </span>

              </div>
            </div>
            <div class="position-relative">
              <InputText
                  v-if="store.order.contactInfo.address.companyAddress.country &&store.order.contactInfo.address.companyAddress.country.value === 'others'"
                  v-model="store.order.contactInfo.address.companyAddress.otherCountry"
                  label-name="personalForm.country"
                  id="otherCountry"
                  required="personalForm.required.country" step="stepTwo"/>
              <span v-if="store.order.contactInfo.address.companyAddress.country.value === 'others'" class="clearButton"
                    v-on:click="selectCzechCountry"><i
                  class="fa fa-times"></i> </span>
            </div>
          </div>
          <!--          INPUT ZEMĚ END-->
        </div>
        <!--        UDAJE O SUBJEKTU END-->

      </form>
      <form>
        <!--        KONTAKTNI UDAJE START-->
        <h6 class="text-primary mt-3 mb-2 font-weight-bold">{{ t('personalForm.headers.kontaktniUdaje') }}</h6>
        <div class="row">

          <!--          INPUT FIRST NAME-->
          <div class="col-12 col-sm-6">
            <InputText v-model="store.order.contactInfo.firstName" label-name="personalForm.firstName" id="firstName"
                       required="personalForm.required.jmeno" step="stepTwo"/>
          </div>

          <!--          INPUT SURNAME-->
          <div class="col-12 col-sm-6">
            <InputText v-model="store.order.contactInfo.surName" label-name="personalForm.surName" id="surName"
                       required="personalForm.required.prijmeni" step="stepTwo"/>
          </div>

          <!--          INPUT EMAIL-->
          <div class="col-12 col-md-6">
            <InputEmail InputText v-model="store.order.contactInfo.email" label-name="personalForm.email" id="email"
                        required="personalForm.required.email" step="stepTwo"/>
          </div>

          <!--          INPUT PHONE START-->
          <div class="col-12 col-md-6">
            <div class="row">
              <div
                  :class="[store.order.contactInfo.phoneCountry.value === 'other' ? 'col-2 col-md-4 col-lg-4' : 'col-4 col-md-5']">
                <div class="dropdown jake-dropdown">
                  <!--                  <span class="label">{{ t('personalForm.phone') }}</span>-->
                  <a class=" dropdown-toggle" href="#" role="button" id="dropdownPhone" data-toggle="dropdown"
                     aria-expanded="false" v-on:click="dropdownCheck">
              <span v-if="store.order.contactInfo.phoneCountry">

      <img v-if="store.order.contactInfo.phoneCountry.iconFile"
           width="20" style="width: 20px!important; vertical-align: text-bottom"
           v-bind:src="store.order.contactInfo.phoneCountry.iconFile" alt=""/>

                {{ store.order.contactInfo.phoneCountry.text }}
              </span>
                  </a>

                  <div class="dropdown-menu" ref="dropdownPhone" aria-labelledby="dropdownPhone">
                <span class="dropdown-item cursorLink" v-for="item in form.phoneCoutries"
                      @click="setPhoneCountry(item)">
         <img v-if="item.iconFile" width="20" style="width: 20px!important;vertical-align: text-bottom"
              v-bind:src="item.iconFile" alt=""/>
                  {{ item.text }}
                </span>

                  </div>
                </div>


              </div>

              <!--              <div class="col-3 col-md-3 pl-0 pr-0" v-if="store.order.contactInfo.phoneCountry.value === 'other'">-->

              <!--                <InputNumber-->
              <!--                    v-model="store.order.contactInfo.phoneCountryCustom"-->
              <!--                    label-name="personalForm.phoneCountryCustom" id="phoneCountryCustom"-->
              <!--                    required="personalForm.required.phoneCountryCustom" step="stepTwo"/>-->

              <!--              </div>-->
              <div class="col d-flex">
                <InputPhoneNumber v-model="store.order.contactInfo.phone" label-name="personalForm.phone" id="tel"
                                  required="personalForm.required.tel" step="stepTwo"/>
              </div>
            </div>
          </div>
          <!--          INPUT PHONE END-->

          <!--          INPUT PLÁNOVANÝ NÁZEV FIRMY POPTÁVKA-->
          <div class="col-12 col-md-6"
               v-if="store.order.type === 'demand' && store.form.osoba==='pravnicka' && store.form.mamIco === 'nemam'">
            <InputText v-model="store.order.contactInfo.address.companyAddress.companyName"
                       :label-name="store.form.osoba==='fyzicka' ? 'personalForm.osvcName' : 'personalForm.companyNameNoIco'"
                       autocomplete="organization"
                       id="companyName"
                       step="stepTwo"/>
          </div>

          <!--          INPUT ICO-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam' && store.order.type === 'demand'">
            <div class="form-label-group mb-1">
              <input type="text" id="ico" class="form-control"
                     :class="{'is-invalid': (isBlurred() || wrongIco) && (!store.order.contactInfo.address.companyAddress.ico || store.order.contactInfo.address.companyAddress.ico.length < 8)}"
                     v-model="store.order.contactInfo.address.companyAddress.ico"
                     v-on:input="preventIcoInputFromLetter"
                     placeholder="{{ t('personalForm.ico') }}"
                     required=""/>
              <label for="postCode"> {{ t('personalForm.ico') }}</label>
              <div id="IcoMessage" class="invalid-feedback">
                {{ t('personalForm.required.ico') }}
              </div>
            </div>
          </div>
          <!--          ICO END-->

          <!--          INPUT POZNÁMKA-->
          <div class="col-6" v-if="store.order.type === 'demand'">
            <InputText v-model="store.order.contactInfo.poznamka" label-name="personalForm.poznamka" id="poznamka"
                       required="" step="stepTwo"/>
          </div>

          <!--          CHECKBOX PERSONAL INFO START-->
          <div class="col-12 col-md-7 mr-auto mt-4 mb-4" style="font-size: 14px">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" :class="{'is-invalid': isBlurred() && !store.order.checkPersonalInfo}"
                     v-model="store.order.checkPersonalInfo" type="checkbox" value=""
                     id="checkAgreement">
              <label class="custom-control-label" for="checkAgreement">
                {{ t('agreement.agreementWith') }}
                <a :href="t('agreement.privacyUrl')" class="text-primary" target="_blank">
                  {{ t('agreement.personalInformations') }}</a>
                <!--                <span v-if="store.order.type === 'order'">-->
                <!--            <br class="d-none d-md-inline">-->
                <!--            {{ t('agreement.andWith') }}-->
                <!--            <a href="/obchodni-podminky" target="_blank">-->
                <!--              {{ t('agreement.obchodniPodminky') }}</a>-->
                <!--              </span>-->
              </label>
              <div v-if="isBlurred() && !store.order.checkPersonalInfo" class="invalid-feedback">
                {{ t('personalForm.required.personalInfo') }}
              </div>
            </div>
          </div>
          <!--          CHECKBOX PERSONAL INFO END-->

        </div>
      </form>
      <div v-if="demandError" class="small font-weight-bold error-block text-danger mb-2 text-center text-md-right pr-md-3" role="alert">
        {{ t('submitError') }}
      </div>
      <div class="row">
        <div class="col-12 col-md-5 px-0 px-md-3 order-last order-md-first text-center text-md-left">
          <hr class="d-md-none mt-0">
          <NeedHelp/>
        </div>
        <div class="col-12 col-md-7 pb-4 text-right d-none d-md-block">
          <button class="btn btn-primary mr-3" type="button" @click='previousStep'>{{ t('buttons.zpet') }}</button>
          <button v-if="store.order.type === 'order'" class="btn btn-secondary px-4" type="button" @click='nextStep'>
            {{ t('buttons.pokracovat') }}
          </button>
          <button v-if="store.order.type === 'demand'" class="btn btn-secondary px-4" type="button" @click='sendDemand'>
            <span v-html="sendingSpinner"/> {{ t('buttons.odeslatPoptavku') }}
          </button>
        </div>
        <div class="col-12 col-md-7 pb-4 text-right d-md-none">
          <div class="row">
            <div class="col-3 text-left">
              <button class="btn btn-sm btn-primary px-2" type="button" @click='previousStep'>{{
                  t('buttons.zpet')
                }}
              </button>
            </div>
            <div class="col">
              <button v-if="store.order.type === 'order'" class="btn btn-sm px-3 btn-secondary" type="button"
                      @click='nextStep'>
                {{ t('buttons.pokracovat') }}
              </button>
              <button v-if="store.order.type === 'demand'" class="btn btn-sm btn-secondary px-4" type="button"
                      @click='sendDemand'><span v-html="sendingSpinner"/>
                {{ t('buttons.odeslatPoptavku') }}
              </button>

            </div>
          </div>

        </div>


      </div>
    </div>
  </div>

</template>

<script lang="ts">
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import InputText from "../FormsInputs/inputText.vue";
import InputEmail from "../FormsInputs/inputEmail.vue";
import InputNumber from "../FormsInputs/inputNumber.vue"
import InputPscNumber from "../FormsInputs/inputPscNumber.vue"

import Tooltip from "../others/Tooltip.vue";
import {store} from "../store.js";


import flagCz from '@/assets/imgs/flags/cz.png';
import flagDe from '@/assets/imgs/flags/de.png';
import flagFr from '@/assets/imgs/flags/fr.png';
import flagGb from '@/assets/imgs/flags/gb.png';
import flagPl from '@/assets/imgs/flags/pl.png';
import flagSk from '@/assets/imgs/flags/sk.png';
import NeedHelp from "../others/NeedHelp.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import InputPhoneNumber from "@/components/FormsInputs/inputPhoneNumber.vue";
import axios from "axios";
import * as EmailValidator from 'email-validator';
import {DemandType, LegalForm, SeatAddressIn, SeatDemand, SeatInContract} from "../../model/SwissDemand";
import {useProductName} from "@/composables/useProductName";
import * as Sentry from "@sentry/vue";

export default {
  name: "StepTwo",
  props: ['currentStep'],
  components: {Steps, NeedHelp, InputText, InputEmail, InputNumber, InputPhoneNumber, InputPscNumber, Tooltip},
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const {orderItemName} = useProductName()
    const select = ref(0)
    return {t, select, orderItemName}
  },
  data() {
    const {t} = useI18n({useScope: 'global'})
    return {
      errors: [],
      store,
      soc: store.order.contactInfo,
      wrongIco: false,
      demandError: false,
      form: {
        phoneCoutries: [
          {
            value: '420',
            text: '+ 420',
            iconName: 'cz.png',
            iconFile: flagCz
          },
          {
            value: '421',
            text: '+ 421',
            iconName: 'sk.png',
            iconFile: flagSk
          },
          {
            value: '49',
            text: '+ 49',
            iconName: 'de.png',
            iconFile: flagDe
          },
          {
            value: '48',
            text: '+ 48',
            iconName: 'pl.png',
            iconFile: flagPl

          },
          {
            value: '44',
            text: '+ 44',
            iconName: 'gb.png',
            iconFile: flagGb
          },
          {
            value: '33',
            text: '+ 33',
            iconName: 'fr.png',
            iconFile: flagFr
          },
          {
            value: 'other',
            text: t('personalForm.phoneCountryCustomCode'),
            iconName: null
          },


        ],
        countries: [
          {
            value: 'czechia',
            iconName: 'cz.png',
            iconFile: flagCz,
            code: 'CZ'
          },
          {
            value: 'slovakia',
            iconName: 'sk.png',
            iconFile: flagSk,
            code: 'SK'
          },
          {
            value: 'germany',
            iconName: 'de.png',
            iconFile: flagDe,
            code: 'DE'
          },
          {
            value: 'polish',
            iconName: 'pl.png',
            iconFile: flagPl,
            code: 'PL'

          },
          {
            value: 'greatBritain',
            iconName: 'gb.png',
            iconFile: flagGb,
            code: 'GB'
          },
          {
            value: 'france',
            iconName: 'fr.png',
            iconFile: flagFr,
            code: 'FR'
          },
          {
            value: 'others',
            iconName: null,
            code: null
          },


        ],
        healthInsurance:
            ['111 – VZP',
              '201 – VOZP',
              '205 – ČPZP',
              '207 – OZP',
              '209 – ZPS',
              '211 – ZPMV',
              '213 – RBP'],
        paymentsTypes: ['payment.card', 'payment.bank']
      },
      aresLoading: false,

    }
  },
  methods: {
    isBlurred() {
      return this.store.form.steps.stepTwo.blurred;
    },
    finishStepEmit(name) {
      //console.log(`hello world`);
      this.nextStep();
    },
    loadFromAres() {
      if (this.store.order.contactInfo.address.companyAddress.ico.length !== 8) {
        this.wrongIco = true;
        return;
      } else {
        this.wrongIco = false;
      }
      this.aresLoading = true;
      // let config = {
      //   method: 'get',
      //   maxBodyLength: Infinity,
      //   url: 'https://europe-west3-haxo-api.cloudfunctions.net/ares?ico=' + this.store.order.contactInfo.address.companyAddress.ico,
      //   headers: {}
      // };

      // test nového ares rest api
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty/' + this.store.order.contactInfo.address.companyAddress.ico,
        headers: {}
      };

      axios.request(config)
          .then((response) => {
            //clear
            this.store.order.contactInfo.address.companyAddress.dic = '';
            this.store.order.contactInfo.address.companyAddress.companyName = '';
            this.store.order.contactInfo.address.companyAddress.street = '';
            this.store.order.contactInfo.address.companyAddress.psc = '';
            this.store.order.contactInfo.address.companyAddress.city = '';

            const data = response.data;

            if (data.dic) {
              this.store.order.contactInfo.address.companyAddress.dic = data.dic;
            }
            if (data.obchodniJmeno) {
              this.store.order.contactInfo.address.companyAddress.companyName = data.obchodniJmeno;
            }
            if (data.sidlo.nazevUlice) {
              this.store.order.contactInfo.address.companyAddress.street = data.sidlo.nazevUlice;
            }
            if (data.sidlo.cisloDomovni)
              this.store.order.contactInfo.address.companyAddress.street += ' ' + data.sidlo.cisloDomovni;
            if (data.sidlo.psc) {
              this.store.order.contactInfo.address.companyAddress.psc = data.sidlo.psc;
            }
            if (data.sidlo.nazevObce) {
              this.store.order.contactInfo.address.companyAddress.city = data.sidlo.nazevObce;
            }
            //konec loadingu
            this.aresLoading = false;
          }).catch((e) => {
        // console.log(e);
        this.aresLoading = false;
      });

    },
    checkStep() {
      // console.log('Starting check step')
      var order = this.store.order;
      this.store.form.steps.stepTwo.filled = false;
      if (store.order.type === 'order') {
        // console.log('Type order');
        if (!order.contactInfo.firstName) return false;
        if (!order.contactInfo.surName) return false;
        if (!order.contactInfo.email) return false;
        if (!order.contactInfo.phone || order.contactInfo.phone.replaceAll(' ', '').length < 9) return false;
        // if (!order.contactInfo.street) return false;
        // if (!order.contactInfo.city) return false;
        // if (!order.contactInfo.psc) return false;
        // if (!order.contactInfo.country) return false;
        // if (!order.paymentType) return false;
        if (this.store.form.mamIco === 'mam') {
          if (!order.contactInfo.address.companyAddress.ico || order.contactInfo.address.companyAddress.ico.length < 8) return false;
          // if (!order.contactInfo.address.companyAddress.dic) return false;
          if (!order.contactInfo.address.companyAddress.street) return false;
          if (!order.contactInfo.address.companyAddress.city) return false;
          if (!order.contactInfo.address.companyAddress.psc || order.contactInfo.address.companyAddress.psc.length < 5) return false;
          if (!order.contactInfo.address.companyAddress.country) return false;
        }

        if (!order.contactInfo.address.companyAddress.companyName) return false;

      } else if (store.order.type === 'demand') {
        // console.log('Type demand');
        if (!order.contactInfo.firstName) return false;
        if (!order.contactInfo.surName) return false;
        if (!order.contactInfo.email) return false;
        if (!order.contactInfo.phone || order.contactInfo.phone.replaceAll(' ', '').length < 9) return false;
        if (this.store.form.mamIco === 'mam' && (!order.contactInfo.address.companyAddress.ico || order.contactInfo.address.companyAddress.ico.length < 8)) return false;
      }

      if (
          !this.checkEmail()
      )
        return false;
      if (!order.checkPersonalInfo) return false;
      // if (order.contactInfo.phoneCountry.value === 'other' && !order.contactInfo.phoneCountryCustom) return false;

      return true;

    },

    nextStep() {
      this.store.form.steps.stepTwo.blurred = true;
      var check = this.checkStep();
      // console.log('check: ' + check);
      if (check) {
        // zkopírování údajú pro fakturaci do dalšího kroku
        if (this.store.form.sameInvoiceAddressOwnSeat) {
          this.store.order.contactInfo.address.invoiceAddress = {...this.store.order.contactInfo.address.companyAddress};
        }
        // pro nově vznikající subjekt se údaje propíší z virtuálního sídla
        if (this.store.form.sameInvoiceAddressOwnSeat && this.store.form.mamIco === 'nemam') {
          const sidlo = this.store.getSeatProduct()[0];
          this.store.order.contactInfo.address.invoiceAddress.psc = this.t('sidla.psc.' + sidlo.codeForTran);
          this.store.order.contactInfo.address.invoiceAddress.city = this.t('sidla.obec.' + sidlo.codeForTran);
          this.store.order.contactInfo.address.invoiceAddress.street = this.t('sidla.ulice.' + sidlo.codeForTran);
        }

        // vytvoření leadu nedokončené objednávky
        this.sendUnfinishedOrderLead();

        this.store.form.steps.stepTwo.visited = true;
        this.store.form.steps.stepTwo.filled = true;
        this.store.form.currentStep = 'stepThree';
        this.store.gaEventNextStep('step3')
        this.store.scrollTop();
      } else {
        this.$nextTick(() => {
          this.store.scrollToErrorInput();
        })
      }

    }
    ,
    sendDemand() {
      if (!this.store.form.formSending) {
        this.store.form.formSending = true;
        this.demandError = false;
        this.store.form.steps.stepTwo.blurred = true;
        var check = this.checkStep();
        // console.log('check: ' + check);
        if (check) {
          //console.log('Odesílám poptávku');
          try {
            this.store.gaEventFinishForm();
            this.store.seatClarityEvent('finish-demand');
            this.store.vueClarityEvent('finish-demand');
          } catch (e) {
            console.error(e);
          }
          this.sendLead();
        } else this.store.form.formSending = false;

      }

    }
    ,
    finishDemand() {
      this.store.form.formSending = false;
      this.store.form.formSucceed = true;
      this.store.form.steps.stepTwo.visited = true;
      this.store.form.steps.stepTwo.filled = true;
      this.store.form.currentStep = 'stepFive';

      this.store.scrollTop();

    }
    ,


// lead - z poptávky
    sendLead() {

      let data;
      try {
        data = this.prepareData();
      } catch (error) {
        this.errorDemand(error);
        return;
      }

      // console.log(JSON.stringify(data));

      var config = {
        method: 'post',
        url: this.store.urls.jakeSwissUrl + '/demand/create-lead/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.axios.post(config.url, config.data, config.headers)
          .then(response => {
            console.log('lead odeslán', response);
            this.finishDemand();
          }, error => {
            this.errorDemand(error);
          });
    }
    ,
    errorDemand(error) {
      console.error('Chyba odeslání poptávky', error);
      // výpadek sítě (bez response) do Sentry neposílat, každá chyba spouští replay a free plán jich má 50/měsíc
      if (!error?.isAxiosError || error.response) {
        Sentry.withScope((scope) => {
          scope.setTag('demand-submit', 'true');
          Sentry.captureException(error);
        });
      }
      this.demandError = true;
      this.store.form.formSending = false;
    }
    ,
    async sendUnfinishedOrderLead() {
      // pokud to už bylo odesláno
      console.log('sendUnfinishedOrderLead');
      let url = "";
      if (this.store.order.raynetLeadId)
        url = this.store.urls.jakeSwissUrl + '/raynet/update-lead/';
      else
        url = this.store.urls.jakeSwissUrl + '/raynet/create-lead/';

      var data = this.prepareData(true);
      var config = {
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      return await this.axios.post(config.url, config.data, config.headers)
          .then(response => {
            console.log('Odeslán nedokončený lead', response);
            if(!this.store.order.raynetLeadId){
              this.store.order.raynetLeadId = response.data.data.data.id;
              console.log('raynetLeadId', this.store.order.raynetLeadId);
            }
            return true;
          })
          .catch(function (error) {
            console.log('Chyba odeslání nedokončeného leadu', error);
            return false;
          });
    }
    ,
    prepareData(order = false) {
      var o = this.store.order;
      var data = {
        "type": order ? "orderSeat" : "demandSeat",
        "leadId": o.raynetLeadId ? String(o.raynetLeadId) : null,
        "email": o.contactInfo.email,
        "phone": store.getFormattedPhoneNumber(),
        "sourceUrl": window.location.href,
        "sourceWeb": window.location.host,
        "currency": this.store.form.currency,
        "items": this.prepareProducts(),
        "addresses": order ? this.prepareOrderAddresses() : this.prepareAddresses(),
        "lang": this.store.form.language,
        "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
        "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
        "orderNote": this.prepareOrderNote(),
      }

      // pokud jde o demand!
      if(!order){
        let demandData : SeatDemand = {
          "type" : DemandType.SEAT,
          "email": o.contactInfo.email,
          "phone": store.getFormattedPhoneNumber(),
          "note": o.contactInfo.poznamka,
          "firstName": o.contactInfo.firstName,
          "lastName": o.contactInfo.surName,
          "faStreet": o.contactInfo.address.invoiceAddress.street,
          "faCity": o.contactInfo.address.invoiceAddress.city,
          "faCountry": o.contactInfo.address.invoiceAddress.country.code,
          "faZipCode": String(o.contactInfo.address.invoiceAddress.psc),
          "sourceUrl": window.location.href,
          "sourceWeb": window.location.host,
          "currency": this.store.form.currency,
          "products": this.prepareProducts(),
          "lang": this.store.form.language,
          "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
          "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
          "legalForm": store.form.osoba as LegalForm,
          "ico": o.contactInfo.address.companyAddress.ico,
          "seatChange": store.form.vyrizeniZmenySidla,
          "seatInContract": store.form.sidloVeSmlouve as SeatInContract,
          "seatAddressIn": store.form.adresaSidlaJe as SeatAddressIn,
          "companyName": o.contactInfo.address.companyAddress.companyName
        }
        return demandData;
      }



      //  console.log(data)
      return data;
    },
    prepareOrderAddresses() {
      var o = this.store.order;
      var arrayAdd = [];

      var invoiceAdd = {
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": o.contactInfo.address.invoiceAddress.street,
        "city": o.contactInfo.address.invoiceAddress.city,
        "country": o.contactInfo.address.invoiceAddress.country.code,
        "postCode": String(o.contactInfo.address.invoiceAddress.psc),
        "addressType": "invoice",
      }
      //  console.log(invoiceAdd);
      arrayAdd.push(invoiceAdd)
      return arrayAdd;

    }
    ,

    prepareAddresses() {
      var o = this.store.order;
      var arrayAdd = [];

      var invoiceAdd = {
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": "",
        "city": "",
        "country": "",
        "postCode": "",
        "addressType": "invoice",
      }
      //  console.log(invoiceAdd);
      arrayAdd.push(invoiceAdd)
      return arrayAdd;
    }
    ,
    prepareProducts() {

      var prodArray = [];
      console.log(this.store.order.products);
      this.store.order.products.forEach((item) => {

        var amount = 1;
        if (item.totalPriceWithVat)
          var totalPriceWithVat = item.totalPriceWithVat
        if (item.totalPriceWithoutVat)
          var totalPriceWithoutVat = item.totalPriceWithoutVat

        if (!item.totalPriceWithoutVat && !item.totalPriceWithVat && item.standardPrice) {
          item.totalPriceWithVat = item.standardPrice * store.getVatForProduct(item);
          item.totalPriceWithoutVat = item.standardPrice;
        }

        if (item.type === 'seat') {
          amount = item.months;
          totalPriceWithVat = item.totalPriceWithVat / amount;
          totalPriceWithoutVat = item.totalPriceWithoutVat / amount;
        }

        var arItem = {
          "type": item.type,
          "name": this.orderItemName(item),
          "code": item.code,
          "amount": amount,
          "priceWithVat": String((Math.round(totalPriceWithVat * 100) / 100)),
          "priceWithoutVat": String((Math.round(totalPriceWithoutVat * 100) / 100)),
          "priceWithVatFormatted": item.totalPriceWithVatFilter,
          "priceWithoutVatFormatted": item.totalPriceWithoutVatFilter,
          "vatRate": item.vatRateId,
          "amountUnit": item.unit,
          "jakeIsId": item.id
        };
        prodArray.push(arItem);

      });
      // console.log(prodArray);
      return prodArray;
      //
      //
      // var prodArray = [];
      // this.store.order.products.forEach(function (item) {
      //       var amount = 1;
      //       var totalPriceWithVat = item.totalPriceWithVat
      //       var totalPriceWithoutVat = item.totalPriceWithoutVat
      //       if (item.type === 'seat') {
      //         amount = item.months;
      //         totalPriceWithVat = item.totalPriceWithVat / amount;
      //         totalPriceWithoutVat = item.standardPrice;
      //       }
      //       var arItem = {
      //         "name": item.name,
      //         "code": item.code,
      //         "amount": 1,
      //         "priceWithVat": String(totalPriceWithVat),
      //         "itemPriceWithoutVat": String(totalPriceWithoutVat),
      //         "vatRate": item.vatRateId,
      //         "amountUnit": item.unit,
      //         "jakeIsId": item.id
      //       };
      //       prodArray.push(arItem);
      //     }
      // )
      // ;
      // // console.log(prodArray);
      // return prodArray;
    }
    ,

    prepareOrderNote() {
      // podrobnosti objednávky pro lead
      var o = this.store.order;
      var oNote = '<b>Souhrn:</b> <br>';
      oNote += `Virtuální sídlo pro <b>${store.form.osoba === 'pravnicka' ? 'právnickou' : 'fyzickou'}</b> osobu`;


      if (store.form.mamIco === 'mam')
        oNote += ` (IČO <b>${o.contactInfo.address.companyAddress.ico}</b>).<br><br>`
      else
        oNote += " (ještě nemá IČO).<br><br>";

      let seat;
      let otherProducts = [];
      o.products.forEach(product => {
        if (product.type === 'seat')
          seat = product;
        else
          otherProducts.push(product);
      })

      // pokud mám ičo
      if (store.form.mamIco === 'mam') {
        oNote += `<b>Vybraná adresa:</b> ${seat.name} ${seat.totalPriceWithoutVatFilter} bez DPH <br>`;
        oNote += `<b>Vyřízení změny v rejstříku:</b> ${store.form.vyrizeniZmenySidla ? 'ano' : 'ne'}<br>`;

        // pokud je vyřízení změny sídla a jedná se o právnickou osobu vypsat dané možnosti
        if (store.form.vyrizeniZmenySidla && store.form.osoba === 'pravnicka') {
          // oNote += `<b>Aktuální sídlo je:</b> ${store.form.sidloVeSmlouve}<br>`;
          // aktuální sídlo je
          oNote += `<b>Aktuální sídlo je:</b> `;
          if (store.form.sidloVeSmlouve === 'konkretniAdresa')
            oNote += 'konkrétní adresa <br>';
          else if (store.form.sidloVeSmlouve === 'obec')
            oNote += 'obec <br>'
          else if (store.form.sidloVeSmlouve === 'nevim')
            oNote += 'nevím, poraďte mi <br>'

          // pokud je zvolená obec tak vypsat zvolenou možnost
          if (store.form.sidloVeSmlouve === 'obec')
            oNote += `<b>Nová adresa sídla je:</b> ${store.form.adresaSidlaJe === 'stejnaObec' ? 've stejné obci' : 'v jiné obci'}<br>`;

          //pokud je zvoleno konkrétní adresa nebo obec tak vypsat položky změny sídla
          if (store.form.sidloVeSmlouve !== 'nevim') {
            oNote += '<b>Položky změny sídla:</b> <br>';
            otherProducts.forEach(element => {
              oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>';
            })
          }
        } else if (store.form.vyrizeniZmenySidla && store.form.osoba === 'fyzicka') {
          // pokud chce vyřízení sídla a jedná se o fyzickou osobu tak vypsat položky
          oNote += '<b>Položky změny sídla:</b> <br>';
          otherProducts.forEach(element => {
            oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>';
          })
        }

        // poznámka
        oNote += `<b>Poznámka:</b> ${o.contactInfo.poznamka}<br>`;

      } else { // pokud nemám ičo
        oNote += `<b>Vybraná adresa:</b> ${seat.name} ${seat.totalPriceWithoutVatFilter} bez DPH <br>`;
        if (store.form.osoba === 'pravnicka')
          oNote += `<b>Plánovaný název firmy:</b> ${o.contactInfo.address.companyAddress.companyName}<br>`;
        // else
        //   oNote += `<b>Jméno a příjmení budoucí OSVČ:</b> ${o.contactInfo.address.companyAddress.companyName}<br>`;
        oNote += `<b>Poznámka:</b> ${o.contactInfo.poznamka}<br>`;
      }


      // oNote += `<b>Sídlo pro:</b> ${store.form.osoba}<br>`;
      // oNote += `<b>Jméno a příjmení: </b> ${store.order.contactInfo.firstName} ${store.order.contactInfo.surName} <br>`
      // oNote += `<b>OSVČ/firma již existuje: </b>${store.form.mamIco === 'mam' ? 'ano' : 'ne'}<br>`;
      //
      // //pokud mám ico
      // if (this.store.form.mamIco === 'mam') {
      //
      //   oNote += '<b>ICO:</b> '+ store.order.contactInfo.address.companyAddress.ico + '<br>';
      //
      //   // přidat změnu sídla ano/ne
      //   oNote +='<b>' + this.t('sendOrder.zmenaSidla') + '</b>'+ ': ' + this.t('sendOrder.values.' + this.store.form.vyrizeniZmenySidla) + '<br>';
      //   //pokud je pravnicka osoba a chce změnu sídla
      //   if (this.store.form.osoba === 'pravnicka' && this.store.form.vyrizeniZmenySidla) {
      //     // aktuální sídlo ve smlouvě je
      //     oNote += '<b>' + this.t('personalForm.headers.sidloVeSmlouve') + '</b>' + ': '
      //         + (this.store.form.sidloVeSmlouve === 'nevim'
      //             ? this.t('personalForm.radioButtons.nevim') //nevím
      //             : this.store.form.sidloVeSmlouve === 'obec' ? 'Obec' //obec
      //                 : this.t('personalForm.radioButtons.konkretniAdresa')) //konkrétní adresa
      //         + '<br>';
      //     // pokud je zvolená obec
      //     if (this.store.form.sidloVeSmlouve === 'obec') {
      //       // připsat nová adresa je stejná | jiná obec.
      //       oNote += '<b>' + this.t('personalForm.headers.novaAdresaJe') + '</b>'
      //           + ': '
      //           + (this.store.form.adresaSidlaJe === 'stejnaObec'
      //               ? 've stejné obci' : 'v jiné obci')
      //           + '<br>';
      //     }
      //   }
      // }
      // oNote += `<b>Poznámka:</b> ${store.order.contactInfo.poznamka}</br>`;
      //
      // oNote += '<br> Produkty: <br>'
      // o.products.forEach(element => {
      //   if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVat + ' Kč bez DPH <br>'
      //   else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.standardPrice + ' Kč bez DPH <br>'
      // });

      return oNote;
    }
    ,

    checkEmail() {
      var email = this.store.order.contactInfo.email;
      // var re = /(.+)@(.+){2,}\.(.+){2,}/;
      // var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}$/;
      // return re.test(email.toLowerCase());
      return EmailValidator.validate(email);
    }
    ,

    setPhoneCountry(item) {
      this.store.order.contactInfo.phoneCountry = item;
      store.lettersInPhoneNumberInput();
    }
    ,
    setCountry(item) {
      this.store.order.contactInfo.address.companyAddress.country = item;
    }
    ,
    setHealthInsurance(item) {
      this.store.order.healthInsurance = item;
    }
    ,
    setPaymentType(item) {
      this.store.order.paymentType = item;
    }
    ,
// clearHealthInsurance() {
//   if (this.store.order.healthInsurance.length > 0) this.store.order.healthInsurance = '';
//
// },
// clearPaymentType() {
//   if (this.store.order.paymentType.length > 0) this.store.order.paymentType = '';
//
// },

    previousStep() {
      //this.store.form.steps.stepOne.filled = false;
      //this.store.form.currentStep = 'stepOne';
      this.store.previousStep();
    }
    ,

// copySeatAddToInvoiceAdd() {
//   if (store.form.sameInvoiceAddressOwnSeat) {
//     this.store.pscFilter();
//     var add = this.store.order.contactInfo;
//     var inv = this.store.order.ownSeatAddress;
//     add.psc = inv.psc
//     add.street = inv.street
//     add.city = inv.city
//
//     this.selectCzechCountry();
//   }
//
// },

    selectCzechCountry() {
      var countries = this.form.countries.filter(function (elem) {
        if (elem.value === "czechia") return elem;
      });
      this.store.order.contactInfo.address.companyAddress.country = countries[0];
    }
    ,

    preventPscInputFromLetter() {
      // store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
      store.order.contactInfo.address.companyAddress.psc = store.order.contactInfo.address.companyAddress.psc.replace(/\D/g, '').substring(0, 5);
    }
    ,
    preventIcoInputFromLetter() {
      // store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
      store.order.contactInfo.address.companyAddress.ico = store.order.contactInfo.address.companyAddress.ico.replace(/\D/g, '').substring(0, 8);
    }
    ,
  }
  ,
  watch: {
    'store.form.currentStep'() {
      this.demandError = false;
    },
  },
  computed: {
    sendingSpinner() {
      if (this.store.form.formSending) {
        return '<img width="20" style="margin-left:-10px; margin-right: 5px;" src="/assets/jake-style/imgs/loading/loading.svg"/> ';
      } else return '';
    }
    ,
  }
  ,
  created() {
    // nastaveni defaultni hodnoty pro phone input dle jazyka mutace (cs→420, sk→421, pl→48, de→49)
    const defaultPhonePrefix = {cs: '420', sk: '421', pl: '48', de: '49', en: '420'}[import.meta.env.VITE_LANGUAGE] || '420';
    var phoneCountries = this.form.phoneCoutries.filter(function (elem) {
      if (elem.value === defaultPhonePrefix) return elem;
    });
    this.store.order.contactInfo.phoneCountry = phoneCountries[0];

    // nastaveni defaultni hodnoty pro country
    this.selectCzechCountry();

  }
  ,

}


</script>

<style lang="scss" scoped>
.clearButton {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  //border: 1px solid red;
  text-align: center;
  bottom: 1px;
  right: 0px;
  font-size: 12px;
  z-index: +1000;
  cursor: pointer;

}

.ares-button {
  position: absolute;
  display: block;
  z-index: +1000;
  top: 16px;
  right: 0px;
}
</style>